import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Overlay = ({
  children,
  type,
  animate = true
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: clsx('ima-overlay', {
      'ima-overlay--animate': animate
    }),
    children: [/*#__PURE__*/_jsx("div", {
      className: "ima-overlay__backdrop"
    }), /*#__PURE__*/_jsx("div", {
      className: "ima-overlay__foreground",
      children: /*#__PURE__*/_jsx("div", {
        className: clsx('ima-overlay__content', `ima-overlay__content--${type}`),
        children: children
      })
    })]
  });
};
export default Overlay;